import { GridLocaleText } from "@mui/x-data-grid";

export const GRID_ZH_LOCALE_TEXT: GridLocaleText = {
  // Root
  noRowsLabel: '没有数据',
  noResultsOverlayLabel: 'No results found.',
  errorOverlayDefaultLabel: 'An error occurred.',

  // Density selector toolbar button text
  toolbarDensity: 'Density',
  toolbarDensityLabel: 'Density',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Standard',
  toolbarDensityComfortable: 'Comfortable',

  // Columns selector toolbar button text
  toolbarColumns: 'Columns',
  toolbarColumnsLabel: 'Select columns',

  // Filters toolbar button text
  toolbarFilters: 'Filters',
  toolbarFiltersLabel: 'Show filters',
  toolbarFiltersTooltipHide: 'Hide filters',
  toolbarFiltersTooltipShow: 'Show filters',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} active filters` : `${count} active filter`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: '查找…',
  toolbarQuickFilterLabel: '查找',
  toolbarQuickFilterDeleteIconLabel: '清除',

  // Export selector toolbar button text
  toolbarExport: 'Export',
  toolbarExportLabel: '导出',
  toolbarExportCSV: '下载(CSV)',
  toolbarExportPrint: '打印',
  toolbarExportExcel: 'Download as Excel',

  // Columns panel text
  columnsPanelTextFieldLabel: '查找列',
  columnsPanelTextFieldPlaceholder: '列标题',
  columnsPanelDragIconLabel: 'Reorder column',
  columnsPanelShowAllButton: '显示所有列',
  columnsPanelHideAllButton: '隐藏所有列',

  // Filter panel text
  filterPanelAddFilter: '添加过滤器',
  filterPanelDeleteIconLabel: '删除',
  filterPanelLinkOperator: '逻辑运算符',
  filterPanelOperators: '运算符', // TODO v6: rename to filterPanelOperator
  filterPanelOperatorAnd: '并且',
  filterPanelOperatorOr: '或者',
  filterPanelColumns: '列',
  filterPanelInputLabel: '数值',
  filterPanelInputPlaceholder: '过滤值',

  // Filter operators text
  filterOperatorContains: '包含',
  filterOperatorEquals: '相等',
  filterOperatorStartsWith: '以xx开头',
  filterOperatorEndsWith: '以xx结尾',
  filterOperatorIs: '是',
  filterOperatorNot: '不是',
  filterOperatorAfter: '在xx后面',
  filterOperatorOnOrAfter: 'is on or after',
  filterOperatorBefore: '在xx前面',
  filterOperatorOnOrBefore: 'is on or before',
  filterOperatorIsEmpty: '是否为空',
  filterOperatorIsNotEmpty: '是否不为空',
  filterOperatorIsAnyOf: '任意一个',

  // Filter values text
  filterValueAny: 'any',
  filterValueTrue: 'true',
  filterValueFalse: 'false',

  // Column menu text
  columnMenuLabel: '菜单',
  columnMenuShowColumns: '显示列',
  columnMenuFilter: '过滤',
  columnMenuHideColumn: '隐藏',
  columnMenuUnsort: '不排序',
  columnMenuSortAsc: '升序',
  columnMenuSortDesc: '降序',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} active filters` : `${count} active filter`,
  columnHeaderFiltersLabel: '显示过滤器',
  columnHeaderSortIconLabel: '排序',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `选中了 ${count.toLocaleString()} 行`
      : `选中了 ${count.toLocaleString()} 行`,

  // Total row amount footer text
  footerTotalRows: '总行数:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Checkbox selection',
  checkboxSelectionSelectAllRows: '全选',
  checkboxSelectionUnselectAllRows: '取消全选',
  checkboxSelectionSelectRow: '选择行',
  checkboxSelectionUnselectRow: '取消选择行',

  // Boolean cell text
  booleanCellTrueLabel: 'yes',
  booleanCellFalseLabel: 'no',

  // Actions cell more text
  actionsCellMore: 'more',

  // Column pinning text
  pinToLeft: '固定到左边',
  pinToRight: '固定到右边',
  unpin: '取消固定',

  // Tree Data
  treeDataGroupingHeaderName: '分组',
  treeDataExpand: '展开',
  treeDataCollapse: '折叠',

  // Grouping columns
  groupingColumnHeaderName: '分组',
  groupColumn: (name) => `按${name}分组`,
  unGroupColumn: (name) => `取消按${name}分组`,

  // Master/detail
  detailPanelToggle: '详情展示',
  expandDetailPanel: '展开',
  collapseDetailPanel: '折叠',

  // Used core components translation keys
  MuiTablePagination: {
    labelDisplayedRows: ({ from, to, count }) =>{
      return `${from} - ${to}条 总共： ${count}`;
    }, 
    labelRowsPerPage:"每页条数："
  },

  // Row reordering text
  rowReorderingHeaderName: 'Row reordering',

  // Aggregation
  aggregationMenuItemHeader: '聚合',
  aggregationFunctionLabelSum: '求和',
  aggregationFunctionLabelAvg: '平均数',
  aggregationFunctionLabelMin: '最小值',
  aggregationFunctionLabelMax: '最大值',
  aggregationFunctionLabelSize: '个数',
};